import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    templateUrl: 'cleaning-type-plan.html',
    selector: 'cleaning-type-plan',
    styleUrls: ['./cleaning-type-plan.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CleaningTypePlan {

  @Input() plan;

}
